"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WITHDRAWAL_REASON_CODES = exports.REJECTION_REASON_CODES = exports.ACCOUNTABILITY_WITHDRAWAL_CODES = exports.WITHDRAWAL_REASONS_BY_CODE = exports.WITHDRAWAL_REASONS = exports.METRIC_EXCLUDED_REJECTION_CODES = exports.REJECTION_REASONS_BY_CODE = exports.REJECTION_REASONS = void 0;
exports.rejectionReasonsForStage = rejectionReasonsForStage;
exports.rejectionStageFor = rejectionStageFor;
exports.REJECTION_REASONS = [
    // --- Screening stage ---
    { code: 'SCR-EXP', label: 'Insufficient relevant experience', triggersPool: false, stage: 'screening' },
    { code: 'SCR-SKILL', label: 'Missing a required skill', triggersPool: false, stage: 'screening' },
    { code: 'SCR-EDU', label: 'Education requirement not met', triggersPool: false, stage: 'screening' },
    { code: 'SCR-SAL', label: 'Salary expectation above range', triggersPool: true, stage: 'screening' },
    { code: 'SCR-NOTICE', label: 'Notice period too long', triggersPool: true, stage: 'screening' },
    { code: 'SCR-LOC', label: 'Location not workable', triggersPool: true, stage: 'screening' },
    {
        code: 'SCR-INCOMPLETE',
        label: 'Application incomplete',
        triggersPool: false,
        stage: 'screening',
        excludedFromMetrics: true,
        note: 'Request to reapply.',
    },
    {
        code: 'SCR-IRRELEVANT',
        label: 'Applied to an unrelated role',
        triggersPool: true,
        stage: 'screening',
        note: 'Warm regret, and suggest other openings.',
    },
    { code: 'SCR-LEVEL', label: 'Strong, but wrong level for this role', triggersPool: true, stage: 'screening' },
    { code: 'SCR-KNOCKOUT', label: 'Failed eligibility criteria', triggersPool: false, stage: 'screening' },
    // §L31 (R6): a manager's No is never a rejection by itself; "Reject the No's" preselects this.
    { code: 'SCR-HM-NO', label: 'Not chosen by the hiring manager', triggersPool: true, stage: 'screening' },
    // ADR 0079 (workflow review D2): an Out on a phone screening. The note names the screening ("Screening 1: …").
    { code: 'SCR-PHONE', label: 'Screened out on the phone call', triggersPool: false, stage: 'screening', note: 'Set by Out on a phone screening; the note names which one.' },
    // --- Assessment stage ---
    { code: 'ASM-FAIL', label: 'Did not meet assessment threshold', triggersPool: false, stage: 'assessment' },
    {
        code: 'ASM-NOSHOW',
        label: 'Did not attend / complete assessment',
        triggersPool: false,
        stage: 'assessment',
        note: 'Separate from failure — never merge the two in reporting.',
    },
    { code: 'ASM-BORDERLINE', label: 'Below threshold but close', triggersPool: true, stage: 'assessment' },
    // --- Interview stage ---
    { code: 'INT-TECH', label: 'Technical capability below the bar', triggersPool: false, stage: 'interview' },
    { code: 'INT-COMM', label: 'Communication below the bar', triggersPool: false, stage: 'interview' },
    {
        code: 'INT-LEAD',
        label: 'Leadership capability below requirement',
        triggersPool: true,
        stage: 'interview',
        note: 'Often fine at a lower level.',
    },
    {
        code: 'INT-FIT',
        label: 'Values or ways-of-working mismatch',
        triggersPool: false,
        stage: 'interview',
        requiresWrittenEvidence: true,
    },
    { code: 'INT-INCONSISTENT', label: 'Claims could not be substantiated', triggersPool: false, stage: 'interview' },
    {
        code: 'INT-INTEGRITY',
        label: 'Integrity concern',
        triggersPool: false,
        stage: 'interview',
        setsDoNotRehire: true,
        note: 'Auto-sets do_not_rehire; HR review required.',
    },
    {
        code: 'INT-NOSHOW',
        label: 'Did not attend interview',
        triggersPool: false,
        stage: 'interview',
        note: 'Two no-shows auto-suggests a cooldown.',
    },
    {
        code: 'INT-STRONG-NOTSEL',
        label: 'Strong candidate, another was stronger',
        triggersPool: true,
        stage: 'interview',
        note: 'The silver-medalist reason.',
    },
    // --- Any stage ---
    { code: 'GEN-FILLED', label: 'Position filled by another candidate', triggersPool: true, stage: 'any' },
    {
        code: 'GEN-CANCELLED',
        label: 'Requisition cancelled',
        triggersPool: true,
        stage: 'any',
        note: 'Prefer stage `closed_job` where applicable (L13).',
    },
    {
        code: 'GEN-UNRESPONSIVE',
        label: 'Candidate stopped responding',
        triggersPool: false,
        stage: 'any',
        minimumContactAttempts: 3,
    },
    {
        code: 'GEN-DNR',
        label: 'Do not rehire',
        triggersPool: false,
        stage: 'any',
        hrLeadOnly: true,
        setsDoNotRehire: true,
        note: 'Reason mandatory and restricted to HR (§L23).',
    },
    {
        code: 'GEN-DUPLICATE',
        label: 'Duplicate application',
        triggersPool: false,
        stage: 'any',
        excludedFromMetrics: true,
        note: 'Administrative — excluded from funnel metrics.',
    },
    {
        code: 'GEN-OFFER-WITHDRAWN',
        label: 'Offer withdrawn by the company',
        triggersPool: true,
        stage: 'any',
        note: 'S23 Q6: set only by withdrawing an offer the candidate has seen; no regret letter.',
    },
];
exports.REJECTION_REASONS_BY_CODE = new Map(exports.REJECTION_REASONS.map((r) => [r.code, r]));
/** The reasons offered at a given stage, plus the always-available `any` set. */
function rejectionReasonsForStage(stage) {
    return exports.REJECTION_REASONS.filter((r) => r.stage === stage || r.stage === 'any');
}
/** Maps a pipeline stage to the §L19 group whose reasons apply there. */
function rejectionStageFor(stage) {
    if (stage === 'screening' || stage === 'new' || stage === 'auto_rejected')
        return 'screening';
    if (stage === 'assessment')
        return 'assessment';
    if (stage === 'interview_1' || stage === 'interview_2' || stage === 'interview_3') {
        return 'interview';
    }
    return 'any';
}
/** §L19 reporting rule: these two are data hygiene and never count as decisions. */
exports.METRIC_EXCLUDED_REJECTION_CODES = exports.REJECTION_REASONS.filter((r) => r.excludedFromMetrics === true).map((r) => r.code);
exports.WITHDRAWAL_REASONS = [
    {
        code: 'WD-OTHER-OFFER',
        label: 'Accepted another offer',
        signal: 'Speed problem — check time-to-fill for this role.',
    },
    {
        code: 'WD-SALARY',
        label: 'Compensation not competitive',
        signal: 'Band problem — check against market.',
    },
    {
        code: 'WD-LOCATION',
        label: 'Location or commute',
        signal: 'Sourcing problem — filter earlier.',
    },
    {
        code: 'WD-ROLE',
        label: 'Role differed from expectations',
        signal: 'JD accuracy problem.',
    },
    { code: 'WD-PERSONAL', label: 'Personal or family reasons', signal: 'No action.' },
    {
        code: 'WD-TIMING',
        label: 'Not the right time',
        signal: 'Pool candidate.',
        triggersPool: true,
    },
    {
        code: 'WD-PROCESS',
        label: 'Process took too long',
        signal: 'Direct accountability signal.',
        surfacesOnProficiency: true,
    },
    {
        code: 'WD-EXPERIENCE',
        label: 'Poor experience during the process',
        signal: 'Escalates to HR automatically.',
        escalatesToHrLead: true,
    },
    {
        code: 'WD-NORESPONSE',
        label: 'Withdrew without giving a reason',
        signal: '',
    },
];
exports.WITHDRAWAL_REASONS_BY_CODE = new Map(exports.WITHDRAWAL_REASONS.map((r) => [r.code, r]));
/**
 * §L20: "the two that matter most — candidates telling you your recruitment operation
 * is failing. They must appear on dashboards rather than being buried."
 */
exports.ACCOUNTABILITY_WITHDRAWAL_CODES = ['WD-PROCESS', 'WD-EXPERIENCE'];
exports.REJECTION_REASON_CODES = exports.REJECTION_REASONS.map((r) => r.code);
exports.WITHDRAWAL_REASON_CODES = exports.WITHDRAWAL_REASONS.map((r) => r.code);
//# sourceMappingURL=reason-codes.js.map